<template>
<!-- 关于我们 -->
    <div>
        <div class="CompanyProfilePage">
            <!-- 顶部图片 -->
            <div class="topCompanyInfo">
                <div class="topCompanyImgInfo">
                    <span>胤石，知名跨境电商品牌孵化，以及电子商务代运营和技术研发解决方案公司</span>
                    <div class="topCompanyContent">
                        <div class="branchOffices">
                            <div class="tcc">
                                <div class="topCompanyImg">
                                    <img loading="lazy" src="@/assets/img/companyProfile/gongsijianjie_03.jpg" >
                                </div>
                                <div class="topCompanyText">
                                    <p class="title">上海胤石网络科技有限公司</p>
                                    <div class="textHide d1">胤石科技从一家销售额过亿的品牌卖家，过渡到专注为中国品牌出海提供定制化、端到端的全渠道服务。涉及店铺运营、数字营销、IT解决方案、等内容。我们的业务覆盖从品牌独立站，到线上购物平台亚马逊、eBay、速卖通、沃尔玛、Wish、Shopee等全渠道的构建。我们始终秉持科技优先原则，基于互联网大数据分析，不断研发运营技术，为企业定制品牌出海方案的同时，赋能品牌自我发展。</div>
                                    <div class="textHide d2"> 每个企业主都有一个品牌梦,当国内竞争愈演愈烈的时候，品牌出海无疑为企业主提供了一个绝好的弯道超车的机会。胤石科技服务的客户以中小品牌为主,经验缺乏、技术缺乏、资金缺乏、是挡在这些中小企业主"走出去"面前的三座大山，胤石凭借多年在品海出海领域的经验积累,力争以最优惠的价格为企业提供最靠谱的服务。为此我们提供了多种合作模式，从传统的代运营到合作更紧密的联合运营，胤石根据每个企业的产品特点，为品牌提供定制化解决方案，为消费者打造完美购物体验，构架起品牌与消费者之间的互通桥梁。</div>
                                </div>
                            </div>
                            <div class="thd3">
                                <div class="textHide d3"> 技术是胤石的DNA，是未来零售的基石，我们始终秉持科技优先原则,基于互联网大数据分析,通过云计算,人工智能等技术的合作运用，不断研发运营技术,为品牌出海保驾护航。服务中小品牌用户，好国货，通全球！</div>
                            </div>
                        </div>
                        <div class="branchOffices">
                            <div class="tcc">
                                <div class="topCompanyImg">
                                    <img loading="lazy" src="@/assets/img/companyProfile/yiyasu.jpg" style="object-fit:cover;">
                                </div>
                                <div class="topCompanyText">
                                    <p class="title">西安易亚速电子商务有限公司成立于2019年，为上海胤石的子公司</p>
                                    <div class="textHide d1">上海胤石网络科技有限公司成立于2014年，公司自成立以来一直秉承： 正直、严谨、创新、热情的价值观与成为跨境电商汽配类第一品牌的公司愿景，于2016年10月成立西安临潼分部、并在2018、19年初先后设立铁山二号仓库、将总部搬迁至闿和阳光广场，占地面积超千平。公司专注于汽车后市场领域内的汽车用品及汽车配件的研发与销售，目前在售汽配类产品近4000种，拥有国内外注册品牌10余个，2018年年销售额超3000万。</div>
                                    <div class="textHide d2"> 每个企业主都有一个品牌梦,当国内竞争愈演愈烈的时候，品牌出海无疑为企业主提供了一个绝好的弯道超车的机会。胤石科技服务的客户以中小品牌为主,经验缺乏、技术缺乏、资金缺乏、是挡在这些中小企业主"走出去"面前的三座大山，胤石凭借多年在品海出海领域的经验积累,2019年，西安临潼分部注册为西安易亚速电子商务有限公司。作为胤石的子公司，我司有信心、也有能力效仿总公司的发展。公司为员工缴纳五险一金，提供具有竞争力的薪资，同时也注重员工的发展，一年两次调薪，提供晋升通道。</div>
                                </div>
                            </div>
                            <div class="thd3">
                                <div class="textHide d3"> 公司目前正处于快速上升的阶段，有巨大的发展空间。我们渴望优秀的人才，唯有你的优秀，才能创造我们共同的事业，让我们一起从优秀走向卓越！</div>
                            </div>
                        </div>
                        <div class="branchOffices">
                            <div class="tcc">
                                <div class="topCompanyImg">
                                    <img loading="lazy" src="@/assets/img/companyProfile/aomasen.jpg" style="object-fit:contain;">
                                </div>
                                <div class="topCompanyText">
                                    <p class="title">深圳奥玛森汽车零部件有限公司，为上海胤石的子公司</p>
                                    <div class="textHide d1">2021年，深圳龙岗分部注册为深圳奥玛森汽车零部件有限公司。作为胤石的子公司，我司有信心、也有能力效仿总公司的发展。公司为员工缴纳五险一金，提供具有竞争力的薪资，同时也注重员工的发展，一年两次调薪，提供晋升通道。</div>
                                    <div class="textHide d2"> </div>
                                </div>
                            </div>
                            <div class="thd3">
                                <div class="textHide d3"> </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 发展历程 -->
            <div class="developmentHistory">
                <div class="allTitle">
                    <p>发展历程</p>
                    <span></span>
                    <div style="text-transform:uppercase;">development history</div>
                </div>
                <div class="dhistoryTextInfo">
                    <div class="wow fadeInUp dtd" data-wow-delay=".2s">
                        <div class="dhistoryTextDate">
                            <div class="dhistoryText" :title="developmentHistory.title1"><div class="textHide">{{developmentHistory.title1}}</div></div> 
                            <div class="triangle"></div>
                            <div class="dhistoryDate">
                                <div></div>
                                <span>2014年</span>    
                            </div>   
                        </div>
                        <div class="dhistoryTextDate">
                            <div class="dhistoryText" :title="developmentHistory.title2"><div class="textHide">{{developmentHistory.title2}}</div></div> 
                            <div class="triangle"></div>
                            <div class="dhistoryDate">
                                <div></div>
                                <span>2016年</span>    
                            </div>
                        </div>
                        <div class="dhistoryTextDate">
                            <div class="dhistoryText" :title="developmentHistory.title3"><div class="textHide">{{developmentHistory.title3}}</div></div> 
                            <div class="triangle"></div>
                            <div class="dhistoryDate">
                                <div></div>
                                <span>2018年</span>    
                            </div>
                        </div>
                        <div class="dhistoryTextDate">
                            <div class="dhistoryText" :title="developmentHistory.title4"><div class="textHide">{{developmentHistory.title4}}</div></div> 
                            <div class="triangle"></div>
                            <div class="dhistoryDate">
                                <div></div>
                                <span>2021年末</span>    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 企业文化 -->
            <div class="corporateCulture">
                <div class="allTitle">
                    <p>企业文化</p>
                    <span></span>
                    <div style="text-transform:uppercase;">corporate culture</div>
                </div>
                <div class="culture">
                    <div class="wow fadeInLeft cultureInfo" data-wow-delay=".3s">
                        <div class="clImg"><img loading="lazy" src="@/assets/img/companyProfile/gongsijianjie_shiming.png" class="climg1"></div>
                        <div class="clTitle">使命</div>
                        <div class="clDesc">好国货，通全球</div>
                    </div>
                    <div class="wow fadeInLeft cultureInfo" data-wow-delay=".1s">
                        <div class="clImg"><img loading="lazy" src="@/assets/img/companyProfile/gongsijianjie_yuanjing.png" class="climg2"></div>
                        <div class="clTitle">愿景</div>
                        <div class="clDesc">值得信赖的品牌出海引领者</div>
                    </div>
                    <div class="wow fadeInRight cultureInfo" data-wow-delay=".1s">
                        <div class="clImg"><img loading="lazy" src="@/assets/img/companyProfile/gongsijianjie_jiazhiguan.png" class="climg3"></div>
                        <div class="clTitle">价值观</div>
                        <div class="clDesc">
                            <div>开放、务实、探索</div> 
                            <div style="text-align:center;">情义、长期主义</div>
                        </div>
                    </div>
                    <div class="wow fadeInRight cultureInfo" data-wow-delay=".3s">
                        <div class="clImg"><img loading="lazy" src="@/assets/img/companyProfile/gongsijianjie_zongzhi.png" class="climg4"></div>
                        <div class="clTitle">宗旨</div>
                        <div class="clDesc">
                            <div>发展员工成就客户</div> 
                            <div>回报股东强大国家</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 公司环境 -->
            <div class="corporateEnvironment">
                <div class="allTitle">
                    <p>公司环境</p>
                    <span></span>
                    <div style="text-transform:uppercase;">Corporate environment</div>
                </div>
                <div class="wow zoomIn ceImg" data-wow-delay=".1s">
                    <div class="ceImg1">
                        <div class="content">
                            <div class="introduce">
                                <span></span>
                                <div>办公中心</div>
                                <span></span>
                            </div>
                            <div class="introduceEng">Office Center</div>
                        </div>
                    </div>
                    <div class="ceImg2">
                        <div class="content">
                            <div class="introduce">
                                <span></span>
                                <div>接待中心</div>
                                <span></span>
                            </div>
                            <div class="introduceEng">Reception Center</div>
                        </div>
                    </div>
                    <div class="ceImg3">
                        <div class="content">
                            <div class="introduce">
                                <span></span>
                                <div>会议中心</div>
                                <span></span>
                            </div>
                            <div class="introduceEng">Conference Center</div>
                        </div>
                    </div>
                    <!-- <img loading="lazy" src="@/assets/img/companyProfile/gongsijianjie_09.jpg" alt="">
                    <img loading="lazy" src="@/assets/img/companyProfile/gongsijianjie_10.jpg" alt="">
                    <img loading="lazy" src="@/assets/img/companyProfile/gongsijianjie_11.jpg" alt=""> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    name: 'YinshiOffcialwebsiteCompanyProfile',

    data() {
        return {
            // 发展历程
            developmentHistory:{
                title1:'胤石成立于中国上海，过去8年间，分支遍及西安、合肥、深圳，在美国、香港、俄罗斯皆设有海外联络处。',
                title2:'推出汽车用品类品牌XUKEY(旭基)、次年推出车辆养护与工具品牌AUTOXBERT(车甲士)、以及零部件品牌OEMassive(奥玛森).走出了品牌出海的第一步，目前三大品牌皆位于各电商平台搜索前列',
                title3:'开始围绕跨境电商场景自研IT信息系统,推出CASHCOWERP中台系统,WMS仓储系统,TMS国际供应链监控系统,CRM客户服务系统等跨境生态技术。截止2021年实现对接各类电商电商平台超30家， 申请各类软件发明及专利逾百个。可为企业提供各类IT解决方案',
                title4:'开始涉足跨境电商代运营业务,凭借领先的国际视野，成功赋能三家品牌客户完成了其在电子商务世界的布局与突破，深得品牌的信赖。未来胤石将打造覆盖全行业，全渠道，一站式品牌出海服务商。',
            }
        };
    },

    mounted() {
        // new this.$WOW.WOW().init()
    },

    methods: {
        ...mapMutations(['GoTop']),
        
    },    
    created(){
        this.$store.state.currentRouter = this.$route.path  //获取当前页面路由
        this.GoTop()
    }
};
</script>

<style lang="scss" scoped>
    // 图片及描述
    .topCompanyInfo{
        height: 1770px;
        // 大图片
        .topCompanyImgInfo{
            background: url(../assets/img/companyProfile/gongsijianjie01_02.jpg);
            height: 400px;
            background-size:100% 400px;
            text-align: center;
            padding:0 270px;
            display: flex;
            flex-direction: column;
            align-items: center;
            span{
                display: inline-block;
                font-size: 36px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                color: #ffffff;
                margin-top: 120px;
            }
            // 文本描述
            .topCompanyContent{
                width: 1280px;
                height: 1695px;
                margin-top: 120px;
                background: #ffffff;
                box-shadow: -1px 0px 19.6px 0.02px rgba(1,0,0,0.20); 
                padding:50px 40px 100px 40px;
                .branchOffices{
                    margin-top:50px;
                }
                .tcc{
                    display: flex;
                }
                // 第三行内容
                .thd3{
                    margin-top: 20px;
                    text-align: left;
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                    font-weight: 400;
                    color: #555555;
                    line-height: 32px
                }
                // 图片
                .topCompanyImg{
                    width: 486px;
                    height: 348px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                // 文本信息
                .topCompanyText{
                    margin-left: 50px;
                    width: 779px;
                    p{
                        font-size: 18px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                        font-weight: 700;
                        text-align: left;
                        color: #3b589a;
                    }
                    div{
                        font-size: 16px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                        font-weight: 400;
                        text-align: left;
                        color: #444444;
                        line-height: 32px;
                        margin-top: 23px;
                    }
                    .d1{
                        -webkit-line-clamp:4;
                    }
                    .d2{
                        -webkit-line-clamp:5;
                    }
                    .d3{
                        -webkit-line-clamp:2;
                    }
                }
                
            }
        }

    }
    // 发展历程
    .developmentHistory{
        margin-top: 100px;
        // 文本和时间区间
        .dhistoryTextInfo{
            margin-top: 50px;
            padding:50px 270px;
            background: url(../assets/img/companyProfile/gongsijianjie_06.jpg);
            background-size:100% 100%;
            .dtd{
                display: flex;
                justify-content: center;
                background: #fff;
                // 文本信息和时间
                .dhistoryTextDate{
                    width: 320px;
                    // height: 290px;
                    // padding:70px 0px 50px 0px;
                    height: 380px;
                    padding:39px 0px 58px 0px;
                    background: #ffffff;
                    position: relative;
                    margin-left: -4px;
                    // 文本
                    .dhistoryText{
                        width: 215px;
                        height: 63%;
                        padding:30px;
                        font-size: 16px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                        font-weight: 400;
                        color: #444444;
                        line-height: 32px;
                        margin: 0 auto;
                        display: flex;
                        align-items: center;
                        text-align: center;
                        cursor: pointer;
                        border-radius: 10px;
                        transition:.2s;
                        div{
                            -webkit-line-clamp:9;
                        }
                    }
                    // 第三个文本内容
                    // .dtthree{
                    //     width: 270px;
                    // }
                    // 三角形
                    .triangle{
                        border-left:10px solid #fff;
                        border-right:10px solid #fff;
                        border-top:10px solid #3c67ab;
                        width:0px;
                        height:0px;
                        margin: 0 auto;
                        transition:.2s all;
                        opacity: 0;
                    }
                    .dhistoryText:hover{
                        background: #3c67ab;
                        color:#fff !important;
                    }
                    .dhistoryText:hover ~ .triangle{
                        opacity: 1 !important;
                    }
                    // 时间
                    .dhistoryDate{
                        position: absolute;
                        bottom: 45px;
                        width: 100%;
                        margin-left: -1px;
                        text-align: center;
                        div{
                            width: 100%;
                            height: 1px;
                            background: black;
                        }
                        div::before{
                            content:'';
                            position: absolute;
                            top: -8px;
                            background: #fff;
                            width: 16px;
                            height: 16px;
                            border: 1px solid #222222;
                            border-radius: 50%;
                            margin-left: -8px;
                            transition: .2s;
                        }
                        span{
                            display: inline-block;
                            margin-top: 28px;
                            font-size: 16px;
                            font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                            font-weight: 700;
                            text-align: center;
                            color: #3b589a;
                        }
                    }
                    .dhistoryText:hover ~ .dhistoryDate div::before{
                            background: #3c67ab;
                            border:1px solid transparent
                    }
                }
            }

        }

    }
    // 企业文化
    .corporateCulture{
        margin-top: 70px;
        // 全部文化div
        .culture{
            padding:50px 270px 70px 270px;
            display: flex;
            justify-content: space-between;
            // 每个文化
            .cultureInfo{
                width: 250px;
                height: 313px;
                background: #3c67ab;
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
                cursor: pointer;
                transition: .2s;
                .clImg{
                    margin-top: 30px;
                    .climg1{
                        width: 49px;
                        height: 52px;
                    }
                    .climg2{
                        width: 37px;
                        height: 50px;
                    }
                    .climg3{
                        width: 58px;
                        height: 50px;
                    }
                    .climg4{
                        width: 50px;
                        height: 50px;
                    }
                }
                .clTitle{
                    margin-top: 50px;
                    font-size: 18px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                    font-weight: 700;
                    color: #45f0ff;
                    text-align: center;
                }
                .clDesc{
                    position: absolute;
                    bottom: 50px;
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                    font-weight: 400;
                    color: #fefefe;
                    line-height: 28px;
                }
            }
            .cultureInfo:hover{
                background: #7492d7;
            }
        }
    }
    // 公司环境
    .corporateEnvironment{
        background: #eeeeee;
        height: 420px;
        padding: 50px 270px 70px 270px;
        .ceImg{
            display: flex;
            justify-content: center;
            margin-top: 50px;
            .ceImg1,.ceImg2,.ceImg3{
                width: 460px;
                height: 306px;
                .content{
                    height: 100%;
                    width: 100%;
                    background-color: rgb(60 103 171 / 80%);
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    color:#fff;
                    transition:.2s;
                    opacity: 0;
                    cursor: pointer;
                    // 介绍
                    .introduce{
                        font-size: 16px;
                        font-weight: 400;
                        display: flex;
                        align-items: center;
                        div{
                            padding: 0 10px;
                        }
                        span{
                            width: 29px;
                            height: 1px;
                            background: #45F0FF;
                        }
                    }
                    // 介绍 英文
                    .introduceEng{
                        text-transform:uppercase;
                        font-size: 14px;
                        font-weight: 400;
                        margin-top: 15px;
                    }
                }
            }
            .ceImg1:hover .content,.ceImg2:hover .content,.ceImg3:hover .content{
                opacity: 1;
            }
            .ceImg1{
                background: url(../assets/img/companyProfile/gongsijianjie_09.jpg);
                background-repeat: no-repeat;
                background-position: center center;
                background-size: cover;
            }
            .ceImg2{
                background: url(../assets/img/companyProfile/gongsijianjie_10.jpg);
                background-repeat: no-repeat;
                background-position: center center;
                background-size: cover;
            }
            .ceImg3{
                background: url(../assets/img/companyProfile/gongsijianjie_11.jpg);
                background-repeat: no-repeat;
                background-position: center center;
                background-size: cover;
            }
            
        }
    }
    // 标题
    .allTitle{
        div{
            color:#b5b5b5;
            font-size: 16px;
        }
    }
</style>